import React, { memo } from "react";
import { Modal } from "react-bootstrap";
import Button from "../Common/Button";

const DeleteModal = ({
  open,
  onClose,
  onSubmit,
  title,
  message,
  buttonText,
  showIcon = true,
}) => {
  const handleDelete = () => {
    onSubmit(); // Call delete function
    onClose();
  };

  return (
    <Modal show={open} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center">
          {showIcon && (
            <img
              src="/deleteIcon.svg"
              alt="delete-icon"
              className="deleteBtnModal"
            />
          )}
          <span style={{ marginLeft: "10px" }}>{title}</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          {/* <Modal.Title>{title}</Modal.Title> */}
          <p>{message}</p>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <Button
          className="px-4 "
          style={{
            height: "45px",
            width: "112px",
            borderRadius: "5px",
            backgroundColor: "white",
            border: "1px solid gray",
            color: "rgb(110, 116, 133)",
            fontFamily: "inherit",
            fontSize: "18px",
          }}
          onClick={() => {
            onClose();
          }}
        >
          Cancel
        </Button>
        <Button
          className="px-4 save-btn fix-width-button"
          onClick={handleDelete}
        >
          {buttonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default memo(DeleteModal);
